import { render, staticRenderFns } from "./AnnualPlayerRanking2022.vue?vue&type=template&id=98c92c46&scoped=true"
import script from "./AnnualPlayerRanking2022.vue?vue&type=script&lang=js"
export * from "./AnnualPlayerRanking2022.vue?vue&type=script&lang=js"
import style0 from "./AnnualPlayerRanking2022.vue?vue&type=style&index=0&id=98c92c46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98c92c46",
  null
  
)

export default component.exports